var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadNewImage(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3626_124302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6461 13.9096L9.97638 12.2441C9.209 11.4787 8.82527 11.0959 8.38349 10.9523C7.99489 10.826 7.57664 10.826 7.18797 10.9523C6.74622 11.0959 6.3625 11.4787 5.59508 12.2441L1.70727 16.1829M11.6461 13.9096L11.9779 13.5785C12.7615 12.7969 13.1532 12.4061 13.6028 12.2636C13.9981 12.1381 14.4228 12.143 14.8152 12.2775C15.2613 12.4306 15.644 12.8303 16.4095 13.6297L17.2221 14.4596M11.6461 13.9096L15.4915 17.8459M1.70727 16.1829C1.73713 16.4375 1.78884 16.6375 1.87844 16.8144C2.06485 17.1824 2.36232 17.4817 2.72819 17.6691C3.14413 17.8823 3.68862 17.8823 4.77761 17.8823H14.1109C14.715 17.8823 15.1515 17.8823 15.4915 17.8459M1.70727 16.1829C1.6665 15.8351 1.6665 15.3852 1.6665 14.7529V5.36468C1.6665 4.26928 1.6665 3.72158 1.87844 3.3032C2.06485 2.93517 2.36232 2.63596 2.72819 2.44845C3.14413 2.23527 3.68862 2.23527 4.77761 2.23527H8.47206M15.4915 17.8459C15.7644 17.8167 15.9752 17.7641 16.1604 17.6691C16.5262 17.4817 16.8237 17.1824 17.0101 16.8144C17.2221 16.396 17.2221 15.8483 17.2221 14.7529V11.0367M15.2776 7.12497V4.19115M15.2776 4.19115V1.25732M15.2776 4.19115H18.1943M15.2776 4.19115H12.3609",
    stroke: "#20C3FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3626_124302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadNewImage);
export default __webpack_public_path__ + "static/media/uploadNewImage.03efe451e5a393ef376b32c2d16606db.svg";
export { ForwardRef as ReactComponent };